var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M8.125 3.04688H5.07812C2.83446 3.04688 1.01562 4.86571 1.01562 7.10938V9.14062H4.0625V7.10938C4.0625 4.86571 5.88133 3.04688 8.125 3.04688Z",
    fill: "url(#paint0_linear_655_2106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10938 1.01562V5.07812M17.2656 1.01562V5.07812M9.98882 23.3594H5.07812C2.83451 23.3594 1.01562 21.5405 1.01562 19.2969V7.10938C1.01562 4.86561 2.83451 3.04688 5.07812 3.04688H19.2969C21.5405 3.04688 23.3594 4.86561 23.3594 7.10938V9.14062H1.01562",
    stroke: "url(#paint1_linear_655_2106)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8906 24.9844C22.2561 24.9844 24.9844 22.2561 24.9844 18.8906C24.9844 15.5251 22.2561 12.7969 18.8906 12.7969C15.5251 12.7969 12.7969 15.5251 12.7969 18.8906C12.7969 22.2561 15.5251 24.9844 18.8906 24.9844Z",
    stroke: "black",
    strokeWidth: 2.03125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8906 16.8594V18.8906H20.9219",
    stroke: "black",
    strokeWidth: 2.03125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_2106",
    x1: 1.01562,
    y1: 3.04687,
    x2: 5.73576,
    y2: 10.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_655_2106",
    x1: 1.41537,
    y1: -1.49672,
    x2: 27.2521,
    y2: 22.7301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_2106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEvent);
export default __webpack_public_path__ + "static/media/calendarEvent.2293affa031ef0cf779e3ce86bd3f75e.svg";
export { ForwardRef as ReactComponent };